// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M11.768.033a.812.812 0 0 0-.18.09c-.044.03-2.46 2.095-5.367 4.588C2.362 8.018.915 9.272.864 9.352a.753.753 0 0 0 .335 1.083c.18.084.423.083.605-.001.093-.044 1.486-1.224 5.156-4.37A1420.89 1420.89 0 0 1 12 1.751c.007 0 2.275 1.94 5.04 4.311 3.733 3.2 5.062 4.327 5.159 4.372a.61.61 0 0 0 .301.061c.585 0 .948-.653.636-1.144C23.05 9.215 12.485.15 12.317.07a.92.92 0 0 0-.549-.036m.06 4.488a.76.76 0 0 0-.228.094c-.12.083-8.62 7.35-8.788 7.513-.242.234-.42.545-.507.89-.048.187-.049.25-.049 4.836 0 5.094-.007 4.81.144 5.133a1.84 1.84 0 0 0 1.002.938l.162.063H9.52l.117-.073a.928.928 0 0 0 .329-.395c.023-.065.03-.882.036-3.534l.007-3.45h3.982l.007 3.45c.005 2.652.013 3.47.036 3.534.046.131.2.315.329.395l.117.073h5.956l.162-.063a1.84 1.84 0 0 0 1.002-.938c.151-.322.143-.039.144-5.133 0-4.586 0-4.649-.049-4.836a1.913 1.913 0 0 0-.543-.924c-.123-.118-8.388-7.188-8.674-7.42a.755.755 0 0 0-.65-.153m-3.845 5.15a915.624 915.624 0 0 0-4.096 3.518.427.427 0 0 0-.117.192c-.035.142-.037 8.816-.001 8.944a.31.31 0 0 0 .087.138c.062.049.082.049 2.35.049h2.289l.006-3.258.007-3.258.057-.144c.164-.41.487-.695.897-.792.224-.053 4.852-.053 5.076 0 .41.097.733.382.897.792l.057.144.007 3.258.006 3.258h2.288c2.27 0 2.289 0 2.35-.05a.31.31 0 0 0 .088-.137c.036-.128.034-8.802-.001-8.943a.447.447 0 0 0-.138-.212 1969.28 1969.28 0 0 0-8.099-6.928c-.003.001-1.807 1.545-4.01 3.43"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const RealEstateIcon = Icon;
export default RealEstateIcon;
